var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "p-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "广告位：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "选择广告位" },
                          model: {
                            value: _vm.form.position_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "position_id", $$v)
                            },
                            expression: "form.position_id",
                          },
                        },
                        _vm._l(_vm.positionList, function (item) {
                          return item.has_access == 1
                            ? _c("el-option", {
                                attrs: {
                                  label: item.name,
                                  value: item.position_id,
                                },
                              })
                            : _vm._e()
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入广告名称" },
                        model: {
                          value: _vm.form.ad_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ad_name", $$v)
                          },
                          expression: "form.ad_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "图片：" } },
                    [
                      _c("upload", {
                        attrs: {
                          "file-list": _vm.fileList,
                          ratio: _vm.proportion[_vm.form.position_id],
                        },
                        on: { fileOk: _vm.fileOk },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.form.orderby,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderby", $$v)
                          },
                          expression: "form.orderby",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间：" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "timestamp",
                          type: "datetimerange",
                          "unlink-panels": true,
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        model: {
                          value: _vm.time,
                          callback: function ($$v) {
                            _vm.time = $$v
                          },
                          expression: "time",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "重定向链接：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder:
                            "请填写关联的公众号文章链接或报名活动链接",
                        },
                        model: {
                          value: _vm.form.ad_link,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ad_link", $$v)
                          },
                          expression: "form.ad_link",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "投放设备：" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.is_all,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "is_all", $$v)
                          },
                          expression: "form.is_all",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__tip" }, [
                        _vm._v(
                          "开启表示投放到全部设备。关闭表示投放到指定设备(编辑提交完成后可到广告列表绑定设备)"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }